/* eslint-disable */
const zhLocale = require("element-ui/lib/locale/lang/zh-CN");
const cn = {
  time: '时间',
  ...zhLocale.default
};

export default cn;